import ApplicationController from './application'

export default class extends ApplicationController {

  static targets = [
    'input',
    'openEye',
    'closedEye',
    'validation'
  ]

  toggle() {
    /** Shows and hides password on the form */
    if (!this.hasInputTarget && !this.hasIconTarget) return

    const input = this.inputTarget
    const newType = input.type === 'password' ? 'text' : 'password'
    input.setAttribute('type', newType)

    if (newType === 'password') {
      this.openEyeTarget.classList.remove('hidden')
      this.closedEyeTarget.classList.add('hidden')
    } else {
      this.openEyeTarget.classList.add('hidden')
      this.closedEyeTarget.classList.remove('hidden')
    }
  }

  validate() {
    if (!this.hasValidationTarget) this.validationWrapper()

    const input = this.inputTarget
    const limitCheck = this.validationTarget.querySelector('.limit')
    const numberCheck = this.validationTarget.querySelector('.number')
    const caseCheck = this.validationTarget.querySelector('.case')
    const validationGroup = this.validationTarget

    input.setAttribute('pattern', '^(?=.*[A-Z])(?=.*[0-9]).{8,128}$')
    this.validateLine(input.value.match('(?=.*[A-Z])'), caseCheck)
    this.validateLine(input.value.match('(?=.*[0-9])'), numberCheck)
    this.validateLine((input.value.length >= 8 && input.value.length <= 128), limitCheck)
    this.validateLine(!(input.value.length > 0), validationGroup, 'hidden')
  }

  validateLine(test, element, className = 'valid') {
    test ? element.classList.add(className) : element.classList.remove(className)
  }

  validationWrapper() {
    const input = this.inputTarget;
    const parentElement = input.closest('[data-controller="password"]');

    const wrapperElement = document.createElement('div');
    wrapperElement.className = 'password-validation';
    wrapperElement.dataset.passwordTarget = 'validation';

    const messages = [
      { class: 'limit', text: '8 to 128 characters' },
      { class: 'number', text: 'At least 1 number' },
      { class: 'case', text: 'At least 1 upper case character' }
    ];

    wrapperElement.innerHTML = messages.map(message => `
      <div class="message ${message.class}">
        <svg class="c-icon__svg" fill="none" focusable="false" height="12" width="12" role="img" stroke="currentColor" stroke-width="0" stroke-linecap="round" stroke-linejoin="round">
          <use href="#icnPasswordCheck" aria-hidden="true"></use>
        </svg>
        <p>${message.text}</p>
      </div>
    `).join('');

    parentElement.appendChild(wrapperElement);
  }
}
